import { put, takeLatest } from 'redux-saga/effects'
import call from '../call'
import { USERMANAGE } from '../actionTypes'
import { transformArea } from '../../utils/util'

import {
  getRoleOptions as getRoleOptionsService,
  getAreaOptions as getAreaOptionsService,
  getEntityOptions as getEntityOptionsService,
  queryUserList as queryUserListService,
  querySearchRoleList as querySearchRoleListService,
} from '../service/userManage'

export function* getRoleOptions(payload: Payload) {
  const data: ResponseData = yield call(getRoleOptionsService, payload)
  if (data && data.code === 0) {
    yield put({
      type: USERMANAGE.UPDATE_STATE,
      payload: {
        userRoleOptions: data.data?.map((item: any) => {
          return {
            label: item.roleName,
            value: item.id,
            resourceIds: item.resourceIds,
            childResourceIds: item.childResourceIds,
          }
        }),
      },
    })
  }
}

export function* getAreaOptions(payload: Payload) {
  const data: ResponseData = yield call(getAreaOptionsService, payload)
  if (data && data.code === 0) {
    yield put({
      type: USERMANAGE.UPDATE_STATE,
      payload: {
        userAreaOptions: transformArea(data.data as [], item => (item.disabled = false)),
      },
    })
  }
}

export function* getEntityOptions(payload: Payload) {
  const data: ResponseData = yield call(getEntityOptionsService, payload)
  if (data && data.code === 0) {
    yield put({
      type: USERMANAGE.UPDATE_STATE,
      payload: {
        userEntityOptions: data.data?.map((item: any) => {
          return {
            label: item.entityName,
            value: item.id,
          }
        }),
      },
    })
  }
}

export function* queryUserList(payload: Payload) {
  const data: ResponseData = yield call(queryUserListService, payload)
  if (data && data.code === 0) {
    const { dataSet, count } = data.data || {}
    yield put({
      type: USERMANAGE.UPDATE_STATE,
      payload: {
        userList: dataSet.map((item: any) => {
          item.userRoleLabel = item.userRole
          item.userTypeLabel = item.userType === 0 ? '平台用户' : '实体用户'
          item.entityNameLabel = ''
          item.statusLabel = item.status === 0 ? '关' : '开'
          item.businessTypeLabel =
            item.businessType === 1
              ? '单车'
              : item.businessType === 2
              ? '电单车'
              : item.businessType === 3
              ? '双业务'
              : ''
          item.entityNameLabel =
            item.entities?.map((child: any) => child.entity.name).join(',') ||
            item.platform?.regions?.map((child: any) => `${child.name}实体权限`).join(',')
          return item
        }),
        total: count,
      },
    })
  }
}

export function* querySearchRoleList(payload: Payload) {
  const data: ResponseData = yield call(querySearchRoleListService, payload)
  if (data && data.code === 0) {
    yield put({
      type: USERMANAGE.UPDATE_STATE,
      payload: {
        searchRoleOptions: data.data,
      },
    })
  }
}

export default function* root() {
  yield takeLatest(USERMANAGE.GET_ROLE_OPTONS_STATE, getRoleOptions)
  yield takeLatest(USERMANAGE.GET_AREA_OPTONS_STATE, getAreaOptions)
  yield takeLatest(USERMANAGE.GET_ENTITY_OPTONS_STATE, getEntityOptions)
  yield takeLatest(USERMANAGE.GET_USER_LISTS_STATE, queryUserList)
  yield takeLatest(USERMANAGE.GET_SEARCH_ROLE_LIST, querySearchRoleList)
}
